import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen text-black">
      <Navbar />
      <main>{children ?? <Outlet />}</main>
      <Footer />
    </div>
  );
}
